import { render, staticRenderFns } from "./member-grade-setting.vue?vue&type=template&id=a955b2dc&scoped=true&"
import script from "./member-grade-setting.vue?vue&type=script&lang=js&"
export * from "./member-grade-setting.vue?vue&type=script&lang=js&"
import style0 from "./member-grade-setting.vue?vue&type=style&index=0&id=a955b2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a955b2dc",
  null
  
)

export default component.exports